export default __webpack_public_path__ + "static/icon-1-1-8edaf7ab6f02903ee1d1942f3931da27.png";